import React, { useState } from 'react'
import './DragAndDropFile.scss'

interface Props {
  onFileSelect: (file: File | null) => void
  label?: string
  accept?: string
}

export default function DragAndDropFile ({
  onFileSelect,
  label = 'Drag and drop a file or click to upload',
  accept = 'image/*'
}: Props): React.ReactElement {
  const [file, setFile] = useState<File | null>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] ?? null
    setFile(selectedFile)
    onFileSelect(selectedFile)
  }

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    const selectedFile = event.dataTransfer.files[0] ?? null
    setFile(selectedFile)
    onFileSelect(selectedFile)
  }

  return (
    <div
      className="drag-and-drop"
      onDragOver={(e) => {
        e.preventDefault()
      }}
      onDrop={handleDrop}
    >
      <label className="drag-and-drop__label">
        <input
          type="file"
          accept={accept}
          onChange={handleFileChange}
          hidden
        />
        <div className="drag-and-drop__content">
          {file !== null ? (
            <p className="drag-and-drop__file-name">{file.name}</p>
          ) : (
            <p>{label}</p>
          )}
        </div>
      </label>
    </div>
  )
}
